export default {
    ModeratorGroup: require('./Group').default,
    ModeratorSlides: require('./Slides').default,
}